import {stripLeadingWww} from "./get-title-from-domain";

export function getEmailAddressFromDomain(domain: string): string {
  if (domain.length === 0 || domain === "uniapneatutkimus.fi") {
    return "aspa@remotest.fi";
  }

  return stripLeadingWww(domain).split(".")[0].toLowerCase() + "@remotest.fi";
}
